<template>
  <u-animate-container>
    <div>
      <front-header />
      <div class="container-section auth-form">
        <div class="max-container">
          <v-row>
            <v-col>
              <u-animate name="fadeInLeft" class="wow" delay="0.6s">
                <div class="login-left-content">
                  <h1>
                    Welcome to
                    <strong>Grow Pharma</strong>
                  </h1>
                  <p>Type in your info and let’s get started!</p>
                  <div class="image-box mt-10">
                    <img
                      src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606299814980.png"
                      alt
                    />
                  </div>
                </div>
              </u-animate>
            </v-col>
            <v-col>
              <u-animate name="fadeInRight" class="d-flex wow" delay="0.6s">
                <div class="login-right-block">
                  <div class="login-box" v-show="step === 1">
                    <h5
                      class="text-center display-1 font-weight-black modal-title"
                    >
                      <strong>CHANGE YOUR PASSWORD</strong>
                    </h5>
                    <ValidationObserver
                      class="vuetify-form"
                      ref="obs"
                      v-slot="{ invalid, validated, passes }"
                    >
                      <v-form class="mt-10">
                        <v-row>
                          <v-col cols="12">
                            <ValidationProvider
                              name="confirm"
                              :rules="passwordRules"
                              v-slot="{ errors, valid }"
                            >
                              <v-text-field
                                :error-messages="errors"
                                :success="valid"
                                v-model.trim="password"
                                :type="show1 ? 'text' : 'password'"
                                placeholder="Your Password"
                                label="New Password *"
                                name="confirm"
                                hint="Password must contain an upper case letter, a numeric character, and a special character"
                              >
                                <template v-slot:append>
                                  <v-btn
                                    icon
                                    @click="show1 = !show1"
                                    tabindex="-1"
                                  >
                                    <v-icon v-if="show1">mdi-eye</v-icon>
                                    <v-icon v-if="!show1">mdi-eye-off</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12">
                            <ValidationProvider
                              rules="required|password:@confirm"
                              v-slot="{ errors, valid }"
                            >
                              <v-text-field
                                v-model="confirmPassword"
                                :error-messages="errors"
                                :success="valid"
                                :type="show2 ? 'text' : 'password'"
                                placeholder="Your Confirm Password"
                                label="Confirm Password *"
                              >
                                <template v-slot:append>
                                  <v-btn
                                    icon
                                    @click="show2 = !show2"
                                    tabindex="-1"
                                  >
                                    <v-icon v-if="show2">mdi-eye</v-icon>
                                    <v-icon v-if="!show2">mdi-eye-off</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" class="text-center mt-5">
                            <v-btn
                              :disabled="invalid || !validated"
                              x-large
                              :min-width="
                                $vuetify.breakpoint.smAndDown ? 275 : 325
                              "
                              min-height="50"
                              color="#FCAE00"
                              :loading="loading"
                              :dark="!invalid"
                              @click="passes(resetPassword)"
                              >Continue</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-form>
                    </ValidationObserver>
                  </div>
                  <div class="login-box" v-show="step === 2">
                    <h5
                      class="text-center display-1 font-weight-black modal-title"
                    >
                      <strong>password change confirmed</strong>
                    </h5>

                    <p class="mt-10 mb-10 text-center title-content">
                      Congrats, you changed your password successfully!
                    </p>

                    <v-row>
                      <v-col cols="12" class="text-center">
                        <v-btn
                          x-large
                          min-width="275"
                          min-height="50"
                          color="#FCAE00"
                          dark
                          @click="done"
                          >Done</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </u-animate>
            </v-col>
          </v-row>
        </div>
      </div>
      <front-footer />
    </div>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { AuthService } from "@/services";
import FrontHeader from "@/components/layouts/FrontHeader";
import FrontFooter from "@/components/layouts/FrontFooter";
import NodeRSA from "node-rsa";

export default {
  name: "Login",
  components: {
    UAnimateContainer,
    UAnimate,
    FrontHeader,
    FrontFooter,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      loading: false,
      step: 1,
      show1: false,
      show2: false,
      password: "",
      confirmPassword: "",
      passwordRules: {
        required: true,
        min: 8,
        max: 32,
        passwordRegex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
      }
    };
  },
  methods: {
    async resetPassword() {
      const key = new NodeRSA(process.env.VUE_APP_PRIVATEKEY);
      this.loading = true;
      const response = await AuthService.resetPassword({
        password: key.encrypt(this.password, "base64"),
        token: this.$route.params.token
      });
      this.loading = false;
      if (response) {
        this.step++;
      }
    },
    done() {
      this.$router.push("/login");
    }
  }
};
</script>
